// extracted by mini-css-extract-plugin
export var divider = "_43-0";
export var dividerText = "_43-1";